// import axios from '../../utils/request';
import axios from 'axios';
import { REFER_TYPE } from '../referType';
import { getJsonObj } from '../../../utils';
// import request from 'ynf-core-engine/request';
import { multilingual } from '../multilingual'

export async function requestRefMeta(referContext, domainKey, serviceCode) {
    let refMeta = referContext.props.refMeta; // 自定义参照数据, 不走接口
    const content = referContext.props.pageStore?.query
    let res;
    if (refMeta) {
        res = typeof refMeta === 'string' ? getJsonObj(refMeta) : refMeta;
    } else {
        const NODE_PATH = '/mdf-node/'
        // let url = `${location.origin}${NODE_PATH}qtmProxy/ypd/pub/ref/getRefMeta?refCode=${referContext.refCode}&domainKey=${domainKey}&serviceCode=${serviceCode}&feV=6`
        let url = `${location.origin}${NODE_PATH}qtmProxy/ypd/pub/ref/getRefMeta?feV=6`
        res = (await axios({
            url,
            method: 'get',
            withCredentials: true,
            params: { ...content, refCode: referContext.refCode, domainKey: domainKey, serviceCode: serviceCode }
        })).data;
    }
    const { code, data, message } = res;
    if (code === 200) {
        let busiObj, entities, containers, enumData, userDefines, newRefMeta;
        if (data.gridMeta.nfwFeData) { // 新协议
            newRefMeta = true;
            entities = data.gridMeta.nfwFeData.children;
            busiObj = data.gridMeta.nfwFeData.busiObj;
            enumData = data.gridMeta.nfwFeData.enumData;
            userDefines = data.gridMeta.nfwFeData.userDefines;
        } else {
            containers = data.gridMeta.viewApplication.view.containers;
            entities = data.gridMeta.viewmodel.entities;
            let cExtProps = getJsonObj(data.gridMeta.viewApplication.cExtProps);
            busiObj = cExtProps.busiObj;
            referContext.cCardKey = data.gridMeta.viewApplication.cCardKey
        }
        let cEntityKeyFld = data.refEntity.cEntityKeyFld; // 主键
        let cEntityNameFld = data.refEntity.cDataClass_lsName || 'name'; // 显示字段(给树用)
        let fullName = data.refEntity.cDataGrid_FullName; // fullName
        let referType = REFER_TYPE.from(data.refEntity.cTpltype);
        let isTreeList = data.refEntity.cTpltype === 'TreeList'; // 树表参照
        let topName;
        if (referType === REFER_TYPE.TREE_TABLE) {
            topName = data.gridMeta?.viewmodel?.cBillName || data.refEntity.name
        }
        let extendField = getJsonObj(data.refEntity.extendField);
        let showStopStatus = extendField.isShowDisabledData?.field === 'stopstatus';
        let cCheckFlds = data.refEntity.cCheckFlds; // 搜索字段(模糊搜索和精准搜索用)
        let cBillnum = data.refEntity.cBillnum; // 参照页面的billNo(给多语接口参数使用)
        let obj = { containers, entities, referType, isTreeList, topName, cEntityKeyFld, cEntityNameFld, showStopStatus, busiObj, fullName, enumData, cCheckFlds, userDefines, newRefMeta, cBillnum };
        await transAgreement(obj, referContext, domainKey, cBillnum);
        return obj;
    } else {
        referContext.props.pageStore.rootStore.utils.message.danger(`${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00032', '获取元数据接口失败:')}${message}`);
        console.error(`${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00032', '获取元数据接口失败:')}${message}`)
    }
}

// 组装新协议
export async function transAgreement(metaDataObj, referContext, domainKey, cBillnum) {
    if (REFER_TYPE.TABLE === metaDataObj.referType || REFER_TYPE.TREE_LIST === metaDataObj.referType) { // 表参照
        if (metaDataObj.newRefMeta) { // 新协议
            // metaDataObj.metaData = metaDataObj.entities.filter(item => item.controlType === 'BillTemplate')[0].children[0].children;
            let temp = metaDataObj.entities.filter(item => item.controlType === 'BillTemplate')[0].children[0];
            if (temp.controlType.toLocaleLowerCase() !== 'table') {
                metaDataObj.metaData = temp.children[0].children[0].children;
            } else {
                metaDataObj.metaData = temp.children;
            }
            // 多语转化
            metaDataObj.metaData = await multilingual(referContext.props.pageStore, metaDataObj.metaData, domainKey, cBillnum);
        } else {
            // metaDataObj.metaData = metaDataObj.entities.filter(item => item.bMain && item.cType === 'Bill')[0].fields;
            metaDataObj.metaData = metaDataObj.containers.filter((item) => {
                return item.cControlType.trim().toLocaleLowerCase() === 'table' || item.cControlType.trim().toLocaleLowerCase() === 'treetable';
            })[0].controls
        }
    } else if (REFER_TYPE.TREE_TABLE === metaDataObj.referType) { // 树表参照 // 树参照不需要metaData
        metaDataObj.metaData = {};
        if (metaDataObj.newRefMeta) { // 新协议
            let temp = metaDataObj.entities.filter(item => item.controlType === 'BillTemplate')[0].children[0].children;
            temp.map(item => {
                if (item.controlType === 'Tree') { // 左树
                    metaDataObj.metaData.tree = item.children
                }
                if (item.controlType === 'Table') { // 右表
                    metaDataObj.metaData.table = item.children
                }
            })
            // 多语转化
            metaDataObj.metaData.table = await multilingual(referContext.props.pageStore, metaDataObj.metaData.table, domainKey, cBillnum, metaDataObj.newRefMeta);
        } else {
            metaDataObj.metaData.tree = metaDataObj.containers.filter(item => { // 左树
                return item.cControlType.trim().toLocaleLowerCase() === 'searchtree' || item.cControlType.trim().toLocaleLowerCase() === 'tree';
            })[0]?.controls
            metaDataObj.metaData.table = metaDataObj.containers.filter(item => { // 右表
                return item.cControlType.trim().toLocaleLowerCase() === 'table' || item.cControlType.trim().toLocaleLowerCase() === 'treetable';
            })[0]?.controls
        }
    } else if (REFER_TYPE.TREE === metaDataObj.referType) {
        if (metaDataObj.newRefMeta) { // 新协议
        } else {
            metaDataObj.metaData = metaDataObj.containers.find((item) => item.cControlType.trim().toLocaleLowerCase() === 'searchtree')?.controls
        }
    }
    if (referContext.props.cEntityKeyFld) { // 如果协议里覆写了主键则优先用meta中的
        metaDataObj.cEntityKeyFld = referContext.props.cEntityKeyFld;
    }
}
